module.exports = __webpack_public_path__ + "static/img/peixun2.b07f3cd3.jpg";